const clean = (value) => String(value || "").replace(/\s+/g, " ").trim();

const richness = (row) =>
  [
    row.chineseName,
    row.formerlyKnownEnglish,
    row.formerlyKnownChinese,
    row.countryOfIncorporation,
  ].filter(Boolean).length;

export const normalizeFwdRelatedCorporates = (rows) => {
  const byName = new Map();

  (rows || []).forEach((row) => {
    const englishName = clean(row?.englishName);
    if (!englishName) return;
    const next = {
      englishName,
      chineseName: clean(row?.chineseName),
      formerlyKnownEnglish: clean(row?.formerlyKnownEnglish),
      formerlyKnownChinese: clean(row?.formerlyKnownChinese),
      countryOfIncorporation: clean(row?.countryOfIncorporation),
    };
    const key = englishName.toLowerCase();
    const current = byName.get(key);
    if (!current || richness(next) > richness(current)) {
      byName.set(key, next);
    }
  });

  return [...byName.values()].sort((a, b) =>
    a.englishName.localeCompare(b.englishName)
  );
};

export const validateFwdRelatedCorporates = (rows) => {
  const seen = new Set();

  for (const row of rows || []) {
    const englishName = clean(row?.englishName);
    if (!englishName) return "English name is required";
    const key = englishName.toLowerCase();
    if (seen.has(key)) return `Duplicate related corporate: ${englishName}`;
    seen.add(key);
  }

  return null;
};
